import React, { PureComponent } from 'react'
import { withAnalytics, WithAnalyticsProps } from '#src/containers/Analytics'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Grid } from '@deal/components'
import { generateGrid } from '#src/services/grid'
import { getSellableEcommerceProperties } from '#src/services/tracking'
import { DepartmentType } from '#src/generated/graphql'
import uuidv4 from 'uuid/v4'
import SellableMetaData from '#src/components/SellableMetaData'
import CategoryChatWidget from '#src/containers/CategoryChatWidget'
import Footer from '#src/components/Footer'
import BackButton from '../../../components/BackButton'
import Expert from '../../../components/Expert'
import HighlightedSpecifications from '../../../components/HighlightedSpecifications'
import ImageCarousel from '../../../components/ImageCarousel'
import JetBooking from '../../../components/JetBooking'
import JetDisclaimer from '../../../components/JetDisclaimer'
import Title from '../../../components/Title'
import { ExperienceBookingProps } from '../../../'
import styles from './styles.css'

class ExperienceBookingPage extends PureComponent<
  ExperienceBookingProps & WithAnalyticsProps & RouteComponentProps<{}>
> {
  private activityId?: string

  constructor(props: ExperienceBookingProps & WithAnalyticsProps & RouteComponentProps<{}>) {
    super(props)

    this.getTrackingProperties = this.getTrackingProperties.bind(this)
  }

  public getTrackingProperties() {
    return Object.assign(
      this.activityId
        ? {
            activity_id: this.activityId
          }
        : {},
      getSellableEcommerceProperties(this.props.sellable)
    )
  }

  public componentDidMount() {
    if (this.props.analytics) {
      this.activityId = uuidv4()

      this.props.analytics.productViewed(this.getTrackingProperties())
    }
  }

  public componentWillUnmount() {
    if (this.props.analytics && this.activityId) {
      this.props.analytics.productViewEnded(this.getTrackingProperties())
    }
  }

  public componentDidUpdate(prevProps: ExperienceBookingProps) {
    if (this.props.analytics && this.props.sellable.id !== prevProps.sellable.id) {
      if (this.activityId) {
        this.props.analytics.productViewEnded(this.getTrackingProperties())
      }

      this.activityId = uuidv4()

      this.props.analytics.productViewed(this.getTrackingProperties())
    }
  }

  public render() {
    const { sellable, expertCuratedOrder } = this.props
    const sellableCategory = sellable.categories[0]

    const defaultTopSection = generateGrid([
      {
        title: 2
      },
      {
        pricing: 2
      },
      {
        highlights: 2
      }
    ])

    const mdTopSection = generateGrid([
      {
        title: 8,
        pricing: 4
      },
      {
        highlights: 8,
        pricing: 4
      }
    ])

    const highlightedSpecifications = [
      'attribute:aircraftType',
      'rawAttribute:Model',
      'attribute:charterCapacity'
    ]

    return (
      <>
        <SellableMetaData sellable={sellable} />
        <div className={styles.content}>
          <CategoryChatWidget categoryId={sellableCategory.id} className={styles.chatHead} />

          <div className={styles.imageCarousel}>
            <BackButton label="Back" />

            <ImageCarousel images={sellable.images} />
          </div>

          <Grid areas={defaultTopSection} areasMd={mdTopSection} className={styles.experience}>
            {({ Title: TitleArea, Pricing: PricingArea, Highlights: HighlightsArea }) => (
              <>
                <TitleArea>
                  <Title
                    title={sellable.title}
                    subTitle={
                      sellable.charterLocation &&
                      sellable.charterLocation.formatted &&
                      sellable.charterLocation.formatted.displayHtml
                    }
                  />
                </TitleArea>

                <PricingArea className={styles.bookingContainer}>
                  <JetBooking expertCuratedOrder={expertCuratedOrder} />
                </PricingArea>

                <HighlightsArea>
                  <HighlightedSpecifications
                    specifications={sellable.specifications.filter(
                      spec => spec.key && highlightedSpecifications.includes(spec.key)
                    )}
                  />
                </HighlightsArea>
              </>
            )}
          </Grid>

          <Expert
            header={
              <>
                <em>Customize your trip</em>, down to the last detail
              </>
            }
            body={
              <>
                Our travel experts are with you from booking to landing. We’re flexible and happy to
                adapt to any last minute changes to your schedule.
              </>
            }
            cta="Connect with your expert"
            categorySlug={sellableCategory.slug}
            departmentType={DepartmentType.JET_CHARTERS}
          />
          <JetDisclaimer />
          <Footer className={styles.footer} />
        </div>
      </>
    )
  }
}

export default withRouter(withAnalytics(ExperienceBookingPage))
